import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";
//{{host_prod}}/{{client_path}}/clinics/{{eos_id}}/sms-gateway/dashboard


const getDashboardData = (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/sms-gateway/dashboard")
}

const getInbox = (clinicId, criteria = "firstName", searchString = "", cursor = null, size = 10, sort = "desc") => {
    let params = "?size=" + size + "&sort=" + sort;
    if (cursor) {
        params += "&cursor=" + encodeURIComponent(cursor);
    }
    if (searchString) {
        params += "&" + criteria + "=" + encodeURIComponent(searchString);
    }
    return axios.get(API_URL + "clinics/" + clinicId + "/sms-gateway/inbox" + params)
}
const getConversation = (clinicId,customer,pageNo=0,pageSize=2) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/sms-gateway/conversation/"+customer+"?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getConversationDetails = (clinicId,customer) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/sms-gateway/conversation/"+customer+"/details")
}
const sendMessage = (clinicId, data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/sms-gateway/send/message",data)
}
const deleteConversation = (clinicId, customer) =>{
    return axios.delete(API_URL+"clinics/"+clinicId+"/sms-gateway/conversation/"+customer)
}

const updateCustomerName = (clinicId, customer, data) => {
    return axios.put(
        API_URL + "clinics/" + clinicId + "/sms-gateway/conversation/" + encodeURIComponent(customer) + "/customer-name",
        data
    );
};

const getFailedMessages = (clinicId, pageNo = 0, pageSize = 10) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/sms-gateway/failed-messages", {
        params: { pageNo, pageSize },
    });
};

const resendFailedMessage = (clinicId, messageId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/sms-gateway/resend-message/" + messageId);
};

const resendFailedMessages = (clinicId, messageIds) => {
    return axios.post(API_URL + "clinics/" + clinicId + "/sms-gateway/failed-messages/resend", {
        messageIds,
    });
};

const deleteFailedMessages = (clinicId, messageIds) => {
    return axios.delete(API_URL + "clinics/" + clinicId + "/sms-gateway/failed-messages", {
        data: { messageIds },
        headers: { 'Content-Type': 'application/json' },
    });
};

const getClinicCustomize = (clinicId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/customizes");
};

const findLegacyEyeconXPatients = (clinicId, patientName, cursor = null, size = 20) => {
    let params = "?patientName=" + encodeURIComponent(patientName) + "&size=" + size;
    if (cursor) {
        params += "&cursor=" + encodeURIComponent(cursor);
    }
    return axios.get(API_URL + "clinics/" + clinicId + "/legacy-eyeconx-patients" + params);
};

const smsgatewayService = {
    getDashboardData,
    getInbox,
    getConversation,
    getConversationDetails,
    sendMessage,
    deleteConversation,
    updateCustomerName,
    getFailedMessages,
    resendFailedMessage,
    resendFailedMessages,
    deleteFailedMessages,
    getClinicCustomize,
    findLegacyEyeconXPatients,
}

export default smsgatewayService